<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Scripts'|translate }}
                </v-card-title>
                <v-card-actions>
                    <span style="width:300px;"><v-text-field class="ml-2" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>
                    <v-btn class="accent mr-2" @click="editedItem=null; dialog=true" :disabled="!$can('update', 'Script')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add'|translate }}
                    </v-btn>
                    <script-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></script-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="scripts"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.active ? 'yes' : 'no' }}</td>
                            <td>{{ props.item.status }}</td>
                            <td>{{ props.item.version }}</td>
                            <td>{{ props.item.updated_on ? formatElderDate(props.item.updated_on) : '' }}</td>
                            <td>
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Script')"
                                    @click="$can('update', 'Script') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Script')"
                                    @click="$can('update', 'Script') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getScript, deleteScript} from '../helper'
import ScriptDialog from "../components/ScriptDialog";
import moment from 'moment'

export default {
    name: 'Scripts',
    components: {ScriptDialog},
    data() {
        return {
            dialog: false,
            headers: [
                {text: this.$options.filters.translate('Name'), value: 'name'},
                {text: this.$options.filters.translate('Active'), value: 'active'},
                {text: this.$options.filters.translate('Status'), value: 'status'},
                {text: this.$options.filters.translate('Version'), value: 'version'},
                {text: this.$options.filters.translate('Updated'), value: 'updated_on'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            scripts: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },

    mounted() {
        this.initialize()
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    methods: {
        initialize() {
            this.refresh()
        },
        formatElderDate(date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },

        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },
        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteScript({
                    'script_id': item.script_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getScript({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.scripts = df['result']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
